import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortBy', standalone: false })
export class SortByPipe implements PipeTransform {
    transform<T>(
        tableRows: T[] | null | undefined,
        ascending: boolean,
        sortKey?: string,
        sortFn?: (a: any, b: any, ascending: boolean) => number
    ): T[] {
        if (!sortKey || !tableRows) {
            return tableRows;
        }
        const predicatePathValues: string[] = sortKey.split('.');

        return [
            ...tableRows.sort((a, b) => {
                let result: any = 0;
                let leftSideValue: any = a;
                let rightSideValue: any = b;

                if (sortFn) {
                    return sortFn(leftSideValue, rightSideValue, ascending);
                }

                predicatePathValues.forEach((predicate) => {
                    leftSideValue = leftSideValue[predicate];
                    rightSideValue = rightSideValue[predicate];
                });

                leftSideValue = (leftSideValue || '').toLowerCase();
                rightSideValue = (rightSideValue || '').toLowerCase();

                if (leftSideValue < rightSideValue) {
                    result = ascending ? -1 : 1;
                } else if (rightSideValue < leftSideValue) {
                    result = ascending ? 1 : -1;
                }
                return result;
            }),
        ];
    }
}
